import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Scrolltop from "../components/Scrolltop";
import TermsOfSales1 from "../components/TermsOfSales";

const TermsOfSales = () => {
  return (
    <>
      <Header />
      <main>
        <TermsOfSales1/>
        <Footer />
      </main>
      <Scrolltop />
    </>
  );
};

export default TermsOfSales;
